import { Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";

const CustomSwitch = withStyles({
  switchBase: {
    color: "white",
    "&$checked": {
      color: "white"
    },
    "&$checked + $track": {
      backgroundColor: "#00BC84",
      opacity: 1
    }
  },
  checked: {}
})(Switch);

class ToggleSwitch extends Component {
  state = {
    isChecked: this.props.value,
    isDisabled: this.props.disabled
  };

  handleChange = () => {
    const { isChecked } = this.state;
    const { id = this.props.fieldName } = this.props;
    this.setState({
      isChecked: !isChecked
    });
    //console.log(`Changed  ${id}  and  ${isChecked}`);
    this.props.onToggle(id, isChecked);
  };

  render() {
    const { isChecked, isDisabled } = this.state;
    return (
      <CustomSwitch
        color="primary"
        checked={isChecked}
        disabled={isDisabled}
        onChange={this.handleChange}
      />
    );
  }
}

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/components/FormElement/ToggleSwitch.js